// @ts-check
// Textos de uma linha de Configurações > Auditoria. A maioria das ações tem rótulo fixo; a cópia do CEP do responsável
// para a família (pacote 1.12.1, contrato 07, seção 9.9.9) guarda só contagens em details, então o rótulo diz quantas
// famílias receberam o CEP (ou que nenhuma recebeu) e a coluna de campos resume o que ficou de fora, para a escola
// saber o que corrigir sem ler o JSON da API. A marcação da LGPD não consentida em quem já tinha se descadastrado
// (pacote 2.0.0, contrato 09 de campanhas base, seção 7) também diz quantas pessoas marcou.
import { hasTranslation, t } from '../i18n/index.js';

/** @typedef {{ action: string, details?: Record<string, unknown> | null, updatedFields?: string[] | null }} AuditLabelEntry */

const POSTCODE_COPY_ACTION = 'household.postcodes_copied';
const MARKETING_OPT_OUT_BACKFILL_ACTION = 'privacy.marketing_opt_out_backfilled';

/** Ações cujo rótulo diz uma contagem guardada em details, e o campo dela. */
const COUNTED_ACTIONS = Object.freeze({ [POSTCODE_COPY_ACTION]: 'copied', [MARKETING_OPT_OUT_BACKFILL_ACTION]: 'count' });

// contagens de details na ordem em que a escola age sobre elas; cleanedWidgetIds é uma lista
const POSTCODE_COPY_SUMMARY = Object.freeze([
  ['ambiguous', 'ambiguous'],
  ['conflicting', 'conflicting'],
  ['notLinked', 'notLinked'],
  ['withoutContactPostcode', 'withoutContactPostcode'],
  ['leadsWithoutHouseholdWithContactPostcode', 'leadsWithoutHousehold'],
  ['cleanedWidgetIds', 'cleanedWidgets'],
]);

/** @param {unknown} value */
const countOf = (value) => (Array.isArray(value) ? value.length : Math.max(0, Number(value) || 0));

/** Rótulo da ação, em pt-BR; ação sem texto aparece com o código. @param {AuditLabelEntry} entry */
export function auditActionLabel(entry) {
  const key = `operations.audit.actions.${entry.action}`;
  if (!hasTranslation(key)) return entry.action;
  const countKey = Object.hasOwn(COUNTED_ACTIONS, entry.action) ? COUNTED_ACTIONS[/** @type {keyof typeof COUNTED_ACTIONS} */ (entry.action)] : null;
  return countKey ? t(key, { count: countOf(entry.details?.[countKey]) }) : t(key);
}

/** Coluna de campos: os campos alterados ou, na cópia do CEP, o que ficou de fora. @param {AuditLabelEntry} entry */
export function auditDetailsText(entry) {
  if (entry.action !== POSTCODE_COPY_ACTION) return entry.updatedFields?.join(', ') ?? '';
  const details = entry.details ?? {};
  return POSTCODE_COPY_SUMMARY
    .map(([detailKey, textKey]) => [countOf(details[detailKey]), textKey])
    .filter(([count]) => Number(count) > 0)
    .map(([count, textKey]) => t(`operations.audit.postcodeCopy.${textKey}`, { count }))
    .join('; ');
}
